<div class="flex-column gap-32">
<app-card preCardTitle="My Account">
  <div *appCardContent class="settings-header-container mb-16">
    <div class="settings-header-title">
      <p>Account Information</p>
      <div class="settings-header-subtitle"></div>
    </div>
    <div class="settings-header-actions">
      <button mat-stroked-button (click)="updateUser()">Edit</button>
    </div>
  </div>

  <div *appCardContent class="my-16">
    <div class="flex-row ops-form">
      <div class="flex-row-left">
        Account ID
      </div>
      <div class="field-with-right-buttons">
          @if (customerId) {
              <span>{{ customerId }}</span>
          }
      </div>
    </div>

    <div class="flex-row ops-form">
      <div class="flex-row-left">
        Name
      </div>
      <div class="field-with-right-buttons">
        <span>{{ user?.givenName}} {{ user?.familyName }}</span>
      </div>
    </div>

    <div class="flex-row ops-form">
      <div class="flex-row-left">
        Email
      </div>
      <div class="field-with-right-buttons">
        <span>{{ user?.email }}</span>
      </div>
    </div>

    <div class="flex-row ops-form">
      <div class="flex-row-left">
        Phone
      </div>
      <div class="field-with-right-buttons">
        <span>{{ user?.phoneNumber }}</span>
      </div>
    </div>

    <div class="flex-row ops-form">
      <div class="flex-row-left">
        Role
      </div>
      <div class="field-with-right-buttons">
          @if (!!user) {
              <span>{{ listRoles() }}</span>
          }
      </div>
    </div>
  </div>

  <div *appCardContent class="settings-header-container mt-16">
    <div class="settings-header-title">
      <p>Password Reset</p>
      <div class="settings-header-subtitle"></div>
    </div>
    <div class="settings-header-actions">
      <button mat-stroked-button (click)="changePassword()">Reset Password</button>
    </div>
  </div>
</app-card>

@if (true) {
<app-card preCardTitle="Public API" class="mt-16">
    <div *appCardContent class="settings-header-container mb-16">
        <div class="settings-header-title">
            <p>Public API keys</p>
        </div>
    </div>

    @if (keysLoading) {
        <div *appCardContent class="my-16">
            <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
        </div>
    } @else {
        <div *appCardContent class="my-16">
            @for (key of apiKeys; track key.id) {
                <div class="flex-row ops-form">
                    <div class="flex-row-left">
                        <span>{{ key.value }}</span>
                        <button mat-button class="mat-small" [cdkCopyToClipboard]="key.value"
                                [matTooltip]="'Copy to clipboard'">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="field-with-right-buttons">
                        <span>{{ key.description }}</span>
                        @if (!!key.validTo) {
                            <span class="ml-8">({{ key.validTo | date: 'shortDate'}})</span>
                        }
                    </div>
                </div>
            }
        </div>
    }
</app-card>
}

</div>